<template>
  <div>
    <a-card title="日管控模板管理">
      <a-row :gutter="16">
        <a-col :span="24" style="max-width: 200px; margin-bottom: 12px">
          <a-input v-model="searchForm.search" placeholder="请输入模板名或编辑人" allowClear @pressEnter="search" />
        </a-col>
        <a-col :span="24" style="width: 100px; margin-bottom: 12px">
          <a-button type="primary" icon="search" @click="search">查询</a-button>
        </a-col>

        <div style="margin-bottom: 12px; float: right">
          <a-button type="primary" icon="plus" style="margin: 0 8px" @click="openTemplateForm('add')">新增模板</a-button>
        </div>
        <div style="margin-bottom: 12px; float: right">
          <a-button type="dashed" icon="file-add" style="margin: 0 8px" @click="handleInitializeTemplate">
            新增初始模板
          </a-button>
        </div>
        <div style="margin-bottom: 12px; float: right">
          <a-button type="default" icon="setting" style="margin: 0 8px" @click="openTemplateItemManager">项目管理</a-button>
        </div>
      </a-row>

      <a-row style="margin-top: 12px">
        <a-table size="small" :columns="columns" :pagination="pagination" :dataSource="templates" rowKey="id"
          :loading="loading" @change="tableChange">
          <div slot="is_default" slot-scope="value, record">
            <a-tag
              :color="value ? 'green' : 'volcano'"
              style="cursor: pointer; user-select: none;"
              @click="toggleDefaultTemplate(record)"
            >
              {{ value ? '默认（点击切换）' : '普通（点击设为默认）' }}
            </a-tag>
          </div>
          <div slot="status" slot-scope="value">
            <a-tag :color="value === 1 ? 'green' : value === 0 ? 'blue' : 'red'">{{
              value === 1 ? "启用" : value === 0 ? "待用" : "禁用"
              }}</a-tag>
          </div>
          <div slot="action" slot-scope="value, record">
            <a-button-group>
              <a-button icon="edit" size="small" @click="openTemplateForm('edit', record)">编辑</a-button>
              <a-button icon="copy" size="small" @click="openTemplateForm('copy', record)">复制</a-button>
              
              <a-popconfirm 
                :title="getDeleteConfirmText(record)" 
                @confirm="deleteTemplate(record.id)"
                ok-text="确认删除"
                cancel-text="取消"
              >
                <a-button 
                  type="danger" 
                  icon="delete" 
                  size="small"
                  :loading="deletingTemplate === record.id"
                >
                  删除
                </a-button>
              </a-popconfirm>
            </a-button-group>
          </div>
        </a-table>
      </a-row>
    </a-card>

    <!-- 模板表单模态框 -->
    <a-modal v-drag-modal v-model="templateFormVisible" :title="getTemplateFormTitle()"
      @ok="handleTemplateSubmit" @cancel="handleTemplateFormCancel" :confirmLoading="templateSubmitLoading"
      width="700px">
      <a-form-model ref="templateForm" :model="templateForm" :rules="templateRules" :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }">
        <a-form-model-item label="模板名称" prop="template_name">
          <a-input v-model="templateForm.template_name" placeholder="请输入模板名称" :maxLength="255" />
          <div class="form-tip" style="color:#999;font-size:12px;">最长255字符，超出将无法保存</div>
        </a-form-model-item>
        <a-form-model-item label="模板描述" prop="description">
          <a-textarea v-model="templateForm.description" placeholder="请输入模板描述" :rows="3" />
        </a-form-model-item>
        <a-form-model-item label="编辑人" prop="update_name">
          <a-select v-model="templateForm.update_name" style="width: 100%" :maxLength="100">
            <a-select-option v-for="item in handlerItems" :key="item.id" :value="item.name">
              {{ item.name }}
            </a-select-option>
          </a-select>
          <div class="form-tip" style="color:#999;font-size:12px;">最长100字符，超出将无法保存</div>
        </a-form-model-item>

        <!-- 在模板表单中，修改关联项目的部分 -->
        <a-form-model-item label="关联项目">
          <div style="max-height: 200px; overflow-y: auto; border: 1px solid #d9d9d9; padding: 8px;">
            <a-checkbox-group v-model="templateForm.selected_items" style="width: 100%;"
              @change="onSelectedItemsChange">
              <div v-for="item in availableItems.data" :key="item.id" style="margin-bottom: 8px;">
                <a-checkbox :value="item.id" style="width: 100%; display: flex; align-items: center;">
                  <span style="margin-left: 8px; max-width: 140px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;" :title="item.item_no + ' - ' + item.item_name">
                    {{ item.item_no }} - {{ item.item_name }}
                    <a-tag :color="item.star === 'high' ? 'red' : 'blue'" size="small" style="margin-left: 8px;">
                      {{ item.star === 'high' ? '高' : '低' }}
                    </a-tag>
                  </span>
                </a-checkbox>
              </div>
            </a-checkbox-group>
          </div>
          <div style="margin-top: 8px; color: #666; font-size: 12px;">
            已选择 {{ templateForm.selected_items ? templateForm.selected_items.length : 0 }} 个项目
          </div>
          <!-- 新增分页组件 -->
          <a-pagination
            :current="itemPage"
            :page-size="itemPageSize"
            :total="availableItems.count"
            :show-size-changer="true"
            :page-size-options="['5','10','20','50']"
            @change="onItemPageChange"
            @showSizeChange="onItemPageSizeChange"
            size="small"
            style="display: inline-block; margin-top: 8px;"
          />
        </a-form-model-item>
        <a-form-model-item label="是否默认模板" prop="is_default">
          <a-select v-model="templateForm.is_default" placeholder="请选择是否默认">
            <a-select-option :value="1">是</a-select-option>
            <a-select-option :value="0">否</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="状态" prop="status">
          <a-select v-model="templateForm.status" placeholder="请选择状态">
            <a-select-option :value="0">待用</a-select-option>
            <a-select-option :value="1">启用</a-select-option>
            <a-select-option :value="2">禁用</a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 新的统一项目管理组件 -->
    <TemplateItemManager ref="templateItemManager" @refresh="handleDataRefresh" />
  </div>
</template>

<script>
import { CheckStatus, Links } from "./data/template.js";
import { dailyControlList, dailyControlDel } from "@/api/control";
import { userOption } from "@/api/option";
import {
  listItems,
  addItem,
  updateItem,
  deleteItem,
  listTemplates,
  addTemplate,
  updateTemplate,
  deleteTemplate,
  initializeTemplate,
} from "@/api/daily";
import {
  listChildItems,
  addChildItem,
  updateChildItem,
  deleteChildItem,
} from "@/api/daily";
import { clearDailyControlCache, clearTemplateCache } from '@/views/control/dailyControl/utils/cacheUtils';
import TemplateItemManager from './components/TemplateItemManager.vue';
import { createSelectionManager } from './composables/useSelectionManager';

export default {
  components: {
    TemplateItemManager,
    // AddForm,
    // TemplateEditor,
  },
  directives: {
    'drag-modal': {
      bind(el) {
        const header = el.querySelector('.ant-modal-header');
        const modal = el.querySelector('.ant-modal');

        if (!header || !modal) return;

        header.style.cssText = 'cursor: move; user-select: none;';

        let isDragging = false;
        let startPos = { x: 0, y: 0 };
        let modalPos = { x: 0, y: 0 };

        const onMouseDown = (e) => {
          isDragging = true;
          startPos = { x: e.clientX, y: e.clientY };

          const rect = modal.getBoundingClientRect();
          modalPos = { x: rect.left, y: rect.top };

          modal.style.cssText += `position: fixed; margin: 0; left: ${modalPos.x}px; top: ${modalPos.y}px;`;
          e.preventDefault();
        };

        const onMouseMove = (e) => {
          if (!isDragging) return;

          const deltaX = e.clientX - startPos.x;
          const deltaY = e.clientY - startPos.y;

          const newX = Math.max(0, Math.min(modalPos.x + deltaX, window.innerWidth - modal.offsetWidth));
          const newY = Math.max(0, Math.min(modalPos.y + deltaY, window.innerHeight - modal.offsetHeight));

          modal.style.left = newX + 'px';
          modal.style.top = newY + 'px';
        };

        const onMouseUp = () => {
          isDragging = false;
        };

        header.addEventListener('mousedown', onMouseDown);
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);

        // 存储清理函数
        el._cleanup = () => {
          header.removeEventListener('mousedown', onMouseDown);
          document.removeEventListener('mousemove', onMouseMove);
          document.removeEventListener('mouseup', onMouseUp);
        };
      },

      unbind(el) {
        el._cleanup?.();
      }
    }
  },
  data() {
    return {
      // 选择管理器（跨页选择的单一真相）
      itemsSelectionManager: createSelectionManager([]),
      templatesSelectionManager: createSelectionManager([]),
      handlerItems: [],
      modelState: {
        link: Links.Plan,
        id: "",
        show: false,
        currentTemplate: null, // 添加当前模板信息
        obj: {},
      },
      CheckStatus,
      Links,
      pagination: { current: 1, total: 0, pageSize: 10 },
      columns: [
        {
          title: "模板名称",
          dataIndex: "template_name",
        },
        {
          title: "模板描述",
          dataIndex: "description",
          width: 200,
          ellipsis: true,
        },
        {
          title: "编辑人",
          dataIndex: "update_name",
        },
        {
          title: "是否默认",
          scopedSlots: { customRender: "is_default" },
          dataIndex: "is_default",
        },
        {
          title: "状态",
          scopedSlots: { customRender: "status" },
          dataIndex: "status",
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: "action" },
          width: "220px",
        },
      ],
      searchForm: { search: "", page: 1, page_size: 10 },
      loading: false,
      initializingTemplate: false,
      templates: [],
      visible: false,
      targetItem: { others: {} },
      form: { others: {} },
      importLoading: false,
      templateModalVisible: false,
      templateForm: {
        template_name: "",
        description: "",
        update_name: "", // Added update_name field
        is_default: 0,
        // daily_control_template_item_id: null,
        status: 0,
        selected_items: [], // 选中的项目ID数组
      },
      availableItems: {
        data: [],
        count: 0,
        page: 1,
        page_size: 10,
        total_pages: 1
      },
      itemPage: 1,
      itemPageSize: 5,
      templateFormVisible: false,
      templateFormMode: "add",
      templateSubmitLoading: false,
      templateRules: {
        template_name: [{ required: true, message: "请输入模板名称", trigger: "blur" }],
        description: [{ required: true, message: "请输入模板描述", trigger: "blur" }],
        update_name: [{ required: true, message: "请输入编辑人", trigger: "blur" }], // Added validation rule
        is_default: [{ required: true, message: "请选择是否默认", trigger: "change" }],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
      },
      
      // 智能操作状态管理
      settingDefault: null, // 当前正在设置默认的模板ID
      deletingTemplate: null, // 当前正在删除的模板ID
      // 可用模板列表（用于项目关联模板选择）
      availableTemplates: [],
    };
  },
  computed: {
    pagedItems() {
      return this.availableItems.data || [];
    }
  },
  methods: {
    // 获取模板表单标题
    getTemplateFormTitle() {
      if (this.templateFormMode === 'add') {
        return '新增模板';
      } else if (this.templateFormMode === 'copy') {
        return '复制模板';
      } else {
        return '编辑模板';
      }
    },
    // 自然排序函数 - 用于正确排序编号（如：1.1, 1.2, ..., 1.10, 1.11）
    naturalSort(a, b) {
      const itemNoA = (a.item_no || '').toString();
      const itemNoB = (b.item_no || '').toString();
      
      // 分割编号为数字部分进行比较
      const partsA = itemNoA.split('.').map(part => parseInt(part) || 0);
      const partsB = itemNoB.split('.').map(part => parseInt(part) || 0);
      
      // 逐段比较
      const maxLength = Math.max(partsA.length, partsB.length);
      for (let i = 0; i < maxLength; i++) {
        const numA = partsA[i] || 0;
        const numB = partsB[i] || 0;
        if (numA !== numB) {
          return numA - numB;
        }
      }
      
      return 0;
    },
    // 关联项目分页切换
    onItemPageChange(page) {
      this.fetchAvailableItems(page, this.itemPageSize);
    },
    onItemPageSizeChange(current, size) {
      this.fetchAvailableItems(1, size);
    },
    // 分页获取项目列表（与项目管理一致）
    fetchAvailableItems(page = 1, page_size = 10) {
      listItems({ page, page_size }).then(response => {
        let items = [];
        let count = 0;
        let total_pages = 1;
        if (response && response.code === 200) {
          if (response.data) {
            items = response.data.data || [];
            count = response.data.count || items.length;
            total_pages = response.data.total_pages || 1;
          }
        }
        // 应用自然排序
        const sortedItems = items.map(item => ({ ...item, id: parseInt(item.id) }))
          .sort((a, b) => this.naturalSort(a, b));
        
        this.availableItems = {
          data: sortedItems,
          count,
          page,
          page_size,
          total_pages
        };
        this.itemPage = page;
        this.itemPageSize = page_size;
      });
    },
    // 打开新的统一项目管理器
    openTemplateItemManager() {
      this.$refs.templateItemManager.show();
    },
    
    // 处理数据刷新 - 当项目管理器中有数据变更时
    handleDataRefresh() {
      // 刷新模板列表，确保显示最新的关联关系
      this.listTemplates();
      // 重新加载可用项目列表
      this.loadAvailableItems();
      // 重新加载可用模板列表
      this.loadAvailableTemplates();
    },
    
    handleDelete(record) {
      this.$confirm({
        title: "确认删除",
        content: `你确定要删除模板 "${record.template_name}" 吗？这个操作不可恢复。`,
        okText: "删除",
        okType: "danger",
        cancelText: "取消",
        onOk: () => {
          deleteTemplate(record.id)
            .then((res) => {
              if (res.code === 200) {
                this.$message.success("模板删除成功");
                this.listTemplates();
              } else {
                this.$message.error(res.message || "删除失败");
              }
            })
            .catch(() => {
              this.$message.error("删除操作失败");
            });
        },
      });
    },
    handleSuccess() {
      this.listTemplates();
    },
    initialize() {
      userOption({ page_size: 999999, is_active: true }).then(data => {
        this.handlerItems = data.results;
        if (this.handlerItems.length > 0&&!this.form.handler) {
          this.form.handler =  this.handlerItems[0].id; // 数据加载完成后设置默认值
        }
      });
      this.listTemplates();
    },
    listTemplates() {
      this.loading = true;
      listTemplates(this.searchForm)
        .then((response) => {

          // 根据开发者工具中看到的响应结构进行处理
          if (response && response.code === 200) {
            // 处理标准响应格式 {code: 200, data: {...}, message: "ok"}
            const responseData = response.data;

            if (responseData && responseData.data && Array.isArray(responseData.data)) {
              // 如果data字段包含数组
              this.templates = responseData.data;
              this.pagination.total = responseData.count || responseData.data.length;
            } else if (responseData && Array.isArray(responseData)) {
              // 如果data直接是数组
              this.templates = responseData;
              this.pagination.total = responseData.length;
            } else {
              console.warn("意外的数据格式:", responseData);
              this.templates = [];
              this.pagination.total = 0;
            }
          } else {
            console.warn("意外的响应格式:", response);
            this.templates = [];
            this.pagination.total = 0;
          }
        })
        .catch((error) => {
          console.error("API错误:", error);
          this.$message.error("获取模板列表失败");
          this.templates = [];
          this.pagination.total = 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    create() {
      this.listTemplates();
    },
    update() {
      this.listTemplates();
    },
    search() {
      this.pagination.current = 1;
      this.searchForm.page = 1;
      this.listTemplates();
    },
    loadAvailableItems() {
      return listItems({})
        .then((response) => {
          let items = [];

          if (response && response.code === 200) {
            items = response.data?.data || response.data || [];
          } else {
            items = response.data || response || [];
          }

          // 确保ID类型一致，都转换为数字，并应用自然排序
          const normalizedItems = items.map(item => ({
            ...item,
            id: parseInt(item.id)
          }));
          
          this.availableItems = normalizedItems.sort((a, b) => this.naturalSort(a, b));

          return this.availableItems;
        })
        .catch((error) => {
          console.error("获取可用项目列表失败:", error);
          this.$message.error("获取可用项目列表失败");
          this.availableItems = [];
          return [];
        });
    },


    openTemplateForm(mode, record) {
  this.templateFormMode = mode;
  if (mode === "edit") {
        // 编辑模式 - 先设置基本信息
        this.templateForm = {
          ...record,
          is_default: Number(record.is_default ?? 0),
          status: parseInt(record.status ?? 1),
          selected_items: [] // 先设置为空数组
        };
        // 加载第一页项目列表并设置选中项
        this.fetchAvailableItems(1, this.itemPageSize);
        if (record.related_items && record.related_items.length > 0) {
          const selectedIds = record.related_items.map(item => parseInt(item.id));
          // seed selection manager with existing selections
          this.itemsSelectionManager.setSelected(selectedIds);
          this.templateForm.selected_items = this.itemsSelectionManager.getAllSelected();
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        }
      } else if (mode === "copy") {
        // 复制模式 - 复制所有信息但生成新的模板名称，并清除id
        this.templateForm = {
          ...record,
          id: undefined, // 清除id，让后端认为这是新增
          template_name: `${record.template_name} - 副本`,
          is_default: 0, // 副本不能是默认模板
          status: parseInt(record.status ?? 1),
          selected_items: [] // 先设置为空数组
        };
        // 加载第一页项目列表并设置选中项（复制关联的项目）
        this.fetchAvailableItems(1, this.itemPageSize);
        if (record.related_items && record.related_items.length > 0) {
          const selectedIds = record.related_items.map(item => parseInt(item.id));
          // seed selection manager with existing selections
          this.itemsSelectionManager.setSelected(selectedIds);
          this.templateForm.selected_items = this.itemsSelectionManager.getAllSelected();
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        }
      } else {
        // 新增模式
        this.templateForm = {
          template_name: "",
          description: "",
          update_name: "",
          is_default: 0,
          status: 1,
          selected_items: []
        };
        this.fetchAvailableItems(1, this.itemPageSize);
      }
      this.templateFormVisible = true;
    },


    handleTemplateSubmit() {
      this.$refs.templateForm.validate((valid) => {
        if (valid) {
          this.templateSubmitLoading = true;
          // 复制模式按新增处理，编辑模式按更新处理
          const apiCall = (this.templateFormMode === "add" || this.templateFormMode === "copy") ? addTemplate : updateTemplate;
          const callWithForce = (force = false) => {
            const payload = { ...this.templateForm };
            if (force) payload.force_confirm = true;
            return apiCall(payload);
          };

          callWithForce(false)
            .then((res) => {
              // 后端要求二次确认覆盖默认模板
              if (res && res.code === 409 && res.data && res.data.need_confirm) {
                this.$confirm({
                  title: '覆盖默认模板',
                  content: (res.data.existing_default_names && res.data.existing_default_names.length)
                    ? `当前操作将覆盖已存在的默认模板：${res.data.existing_default_names.join('、')}，是否继续？`
                    : '当前操作将覆盖已存在的默认模板，是否继续？',
                  okText: '确认覆盖',
                  okType: 'danger',
                  cancelText: '取消',
                  width: 520,
                  onOk: () => {
                    // 用户确认后带 force_confirm 重试一次
                    this.templateSubmitLoading = true;
                    callWithForce(true)
                      .then((res2) => {
                        if (res2 && res2.code === 200) {
                          const actionText = this.templateFormMode === 'copy' ? '复制' : (this.templateFormMode === 'add' ? '新增' : '更新');
                          this.$message.success(`${actionText}模板成功`);
                          
                          // 清除缓存 - 确保日管控使用最新模板
                          clearDailyControlCache();
                          
                          this.handleTemplateFormCancel();
                          this.listTemplates();
                          this.loadAvailableTemplates();
                        } else {
                          this.$message.error(res2?.message || '操作失败');
                        }
                      })
                      .catch((err2) => {
                        this.$message.error('请求失败: ' + (err2.message || '请检查网络'));
                      })
                      .finally(() => {
                        this.templateSubmitLoading = false;
                      });
                  },
                  onCancel: () => {
                    this.$message.info('已取消操作');
                  }
                });
              } else if (res && res.code === 200) {
                const actionText = this.templateFormMode === 'copy' ? '复制' : (this.templateFormMode === 'add' ? '新增' : '更新');
                this.$message.success(`${actionText}模板成功`);
                
                // 清除缓存 - 确保日管控使用最新模板
                clearDailyControlCache();
                
                this.handleTemplateFormCancel();
                this.listTemplates();
                this.loadAvailableTemplates();
              } else {
                const actionText = this.templateFormMode === 'copy' ? '复制' : (this.templateFormMode === 'add' ? '新增' : '更新');
                this.$message.error(res?.message || `${actionText}模板失败`);
              }
            })
            .catch((error) => {
              this.$message.error(`请求失败: ${error.message || '请检查网络连接'}`);
            })
            .finally(() => {
              this.templateSubmitLoading = false;
            });
        }
      });
    },


    handleTemplateFormCancel() {
      this.templateFormVisible = false;
      // 重置表单数据
      this.templateForm = {
        template_name: "",
        description: "",
        update_name: "",
        is_default: 0,
        status: 1,
        selected_items: []
      };
      this.$refs.templateForm.resetFields();
    },
    deleteTemplate(id) {
      // 设置loading状态
      this.deletingTemplate = id;
      
      // 直接调用删除，让后端API处理确认逻辑
      this.performDeleteTemplate(id, false);
    },

    // 执行删除模板操作
    performDeleteTemplate(id, forceDelete = false) {
      const deleteData = {
        id: id,
        force_delete: forceDelete
      };

      deleteTemplate(deleteData)
        .then((response) => {

          // 检查是否需要二次确认
          if (response.code === 409 && response.data?.need_confirm) {
            this.showDeleteConfirmDialog(id, response);
          } else if (response.code === 200) {
            this.$message.success("删除模板成功");
            
            // 清除缓存 - 确保日管控使用最新模板
            clearDailyControlCache();
            
            this.refreshAllData();
          } else {
            this.$message.error(response.message || "删除模板失败");
          }
        })
        .catch((error) => {
          console.error('删除失败:', error);
          if (error.response?.data?.message) {
            this.$message.error(error.response.data.message);
          } else {
            this.$message.error("删除模板失败");
          }
        })
        .finally(() => {
          // 清除loading状态
          this.deletingTemplate = null;
        });
    },

    // 显示删除确认对话框
    showDeleteConfirmDialog(id, response) {
      const { related_item_count, related_items } = response.data;
      const itemNames = related_items?.join('、') || '';

      this.$confirm({
        title: "确认删除关联模板",
        content: `该模板已与 ${related_item_count} 个项目关联${itemNames ? `（${itemNames}）` : ''}，删除后将同时删除这些关联关系，确认删除吗？`,
        okText: "强制删除",
        okType: "danger",
        cancelText: "取消",
        width: 500,
        onOk: () => {
          this.performDeleteTemplate(id, true); // 强制删除
        },
        onCancel: () => {
          this.$message.info("已取消删除操作");
        }
      });
    },
    tableChange(pagination, filters, sorter) {
      this.searchForm.page = pagination.current;
      this.pagination.current = pagination.current;
      this.searchForm.ordering = `${sorter.order == "descend" ? "-" : ""}${sorter.field}`;
      this.listTemplates();
    },
    
    // 初始化模板（一键创建）
    handleInitializeTemplate() {
      this.$confirm({
        title: '确认创建初始模板？',
        content: '将会创建一个包含完整默认数据的「食品生产企业日常监督检查表」模板，包含 7 个主项目和 44 个子项目。您可以在创建后直接编辑使用。',
        okText: '确认创建',
        cancelText: '取消',
        onOk: async () => {
          try {
            this.loading = true;
            const response = await initializeTemplate({});
            
            if (response.code === 200) {
              this.$message.success(response.message || '初始模板创建成功！');
              // 刷新模板列表
              await this.listTemplates();
            } else {
              this.$message.error(response.message || '创建失败');
            }
          } catch (error) {
            console.error('创建初始模板失败:', error);
            this.$message.error(error.response?.data?.message || '创建失败，请稍后重试');
          } finally {
            this.loading = false;
          }
        },
      });
    },
    
    // 新增：加载可用模板列表

    loadAvailableTemplates() {
      return listTemplates({})
        .then((response) => {
          let templates = [];

          if (response && response.code === 200) {
            const responseData = response.data;
            if (responseData && responseData.data && Array.isArray(responseData.data)) {
              templates = responseData.data;
            } else if (responseData && Array.isArray(responseData)) {
              templates = responseData;
            }
          }

          // 确保ID类型一致，都转换为数字，并过滤启用状态的模板
          this.availableTemplates = templates
            .filter(template => template.status === 1) // 只显示启用的模板
            .map(template => ({
              ...template,
              id: parseInt(template.id)
            }));

          // ('处理后的availableTemplates:', this.availableTemplates);
          return this.availableTemplates;
        })
        .catch((error) => {
          console.error("获取可用模板列表失败:", error);
          this.$message.error("获取可用模板列表失败");
          this.availableTemplates = [];
          return [];
        });
    },



    // 添加选择变化的监听方法（使用 selection manager）
    onSelectedItemsChange(checkedValues) {
      try {
        const pageIds = (this.availableItems.data || []).map(i => i.id);
        const merged = this.itemsSelectionManager.replaceForPage(pageIds, checkedValues || []);
        this.templateForm.selected_items = merged;
        // keep form in sync
      } catch (err) {
        console.error('items selection merge failed, fallback:', err);
        this.templateForm.selected_items = checkedValues;
      }
    },

    // 统一的数据刷新方法
    refreshAllData() {
      this.listTemplates();
      this.loadAvailableItems();
      this.loadAvailableTemplates();
    },
    
    // =============智能默认模板管理============= 
    
    // 新增：点击“是否默认”标签切换默认状态
    async toggleDefaultTemplate(template) {
      if (this.settingDefault) return; // 防止重复点击
      if (template.is_default) {
        // 已是默认，点击后变为普通
        this.settingDefault = template.id;
        try {
          const payload = {
            ...template,
            is_default: 0
          };
          const res = await updateTemplate(payload);
          if (res && res.code === 200) {
            this.$message.success('已取消默认模板');
            clearDailyControlCache();
            this.listTemplates();
          } else {
            this.$message.error(res?.message || '操作失败');
          }
        } catch (err) {
          this.$message.error('操作失败: ' + (err.message || '未知错误'));
        } finally {
          this.settingDefault = null;
        }
      } else {
        // 不是默认，点击后设为默认
        // 优化：本地判断是否已存在默认模板，若存在则二次提示
        const hasDefault = this.templates.some(t => t.is_default && t.id !== template.id);
        if (hasDefault) {
          this.$confirm({
            title: '确认覆盖默认模板',
            content: '当前已存在默认模板，继续操作将覆盖原有默认模板，是否继续？',
            okText: '确认覆盖',
            okType: 'danger',
            cancelText: '取消',
            width: 520,
            onOk: async () => {
              this.settingDefault = template.id;
              try {
                const payload = {
                  ...template,
                  is_default: 1,
                  force_confirm: true
                };
                const res = await updateTemplate(payload);
                if (res && res.code === 200) {
                  this.$message.success('已设为默认模板');
                  clearDailyControlCache();
                  this.listTemplates();
                } else {
                  this.$message.error(res?.message || '操作失败');
                }
              } catch (err2) {
                this.$message.error('操作失败: ' + (err2.message || '未知错误'));
              } finally {
                this.settingDefault = null;
              }
            },
            onCancel: () => {
              this.$message.info('已取消操作');
              this.settingDefault = null;
            }
          });
        } else {
          this.settingDefault = template.id;
          try {
            const payload = {
              ...template,
              is_default: 1
            };
            const res = await updateTemplate(payload);
            if (res && res.code === 200) {
              clearDailyControlCache();
              this.$message.success('已设为默认模板');
              this.listTemplates();
            } else {
              this.$message.error(res?.message || '操作失败');
            }
          } catch (err) {
            this.$message.error('操作失败: ' + (err.message || '未知错误'));
          } finally {
            this.settingDefault = null;
          }
        }
      }
    },
    
    // 获取删除确认文本 - 显示将要删除的关联信息
    getDeleteConfirmText(template) {
      const hasRelatedItems = template.related_items && template.related_items.length > 0;
      
      if (template.is_default) {
        return `「${template.template_name}」是默认模板，删除后系统将自动选择其他模板作为默认模板。\n\n确定要删除吗？`;
      }
      
      if (hasRelatedItems) {
        const itemCount = template.related_items.length;
        const itemNames = template.related_items.slice(0, 2).map(item => item.item_name).join('、');
        const displayText = itemCount > 2 ? `${itemNames}等${itemCount}个项目` : itemNames;
        
        return `「${template.template_name}」已与项目"${displayText}"关联，删除后将同时删除这些关联关系。\n\n确定要删除吗？`;
      }
      
      return `确定要删除模板「${template.template_name}」吗？`;
    },
  },
  mounted() {
    this.initialize();
    this.loadAvailableItems(); // 初始化时加载可用项目
    this.loadAvailableTemplates(); // 初始化时加载可用模板
  },
};
</script>